// @ts-nocheck

import React, { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import useMergeProps from '../../hooks/useMergeProps';
import RoutesRedirectionFactory from '../../utils/routes/RoutesRedirectionFactory';

import legacyWinModalContentPropsSelector from './WinModalContent.selector';

import WinModalContent from '.';

type WinModalContentContainerProps = {
  className?: string;
  betslipIds: Array<string>;
};

const WinModalContentContainer = ({ betslipIds, ...ownProps }: WinModalContentContainerProps) => {
  const history = useHistory();
  const selectorProps = useMemo(() => ({ betslipIds }), [betslipIds]);
  const selectedProps = useSelector((state) => legacyWinModalContentPropsSelector(state, selectorProps));

  const openBetshare = useCallback(
    (betslipReference: string) => {
      history.push(RoutesRedirectionFactory.getHistoryShareBetslipRoutePathname(betslipReference));
    },
    [history],
  );

  const openHistory = useCallback(
    (betslipReference: string) => {
      history.replace(`/history`, { betslipReference });
    },
    [history],
  );

  const otherProps = useMemo(
    () => ({
      openBetshare,
      openHistory,
    }),
    [openBetshare, openHistory],
  );

  const enhancedProps = useMergeProps({ ownProps, selectedProps, otherProps });

  return <WinModalContent {...enhancedProps} />;
};

export default WinModalContentContainer;
